import React from 'react'
import { Col, Row } from "react-bootstrap";
import NavBarDashboard from '../../Components/DashboardComponents/NavBarDashboard';
import AdminSideBar from '../../Components/DashboardComponents/AdminSideBar';
import Slot from '../../Components/SlotsComponent/Slot';
const SlotsPage = () => {
    return (
        <div>
            <Row className="py-3">
                <Col sm="5" xs="3" md="2" lg="2">
                    <AdminSideBar/>
                </Col>
                <Col sm="12" xs="9" className='px-5' md="12" lg="10">
                    <NavBarDashboard/>
                    <Slot/>
                </Col>
            </Row>
        </div>
    )
}

export default SlotsPage
